import React from 'react'
import ManageOnlineAdmissionComp from '../../components/adminDashboard/desktop/ManageOnlineAdmissionComp'
import '../../sassFiles/sassPages/admindashboard/manageonlineadmission.scss'
import '../../sassFiles/sassPages/admindashboard/mobile/manageonlineadMb.scss'
import AdDashSidebarmb from '../../components/mobile/dashbordMobile/AdminDashboard/AdDashSidebarmb'
import ManageOnlineAdMbComp from '../../components/adminDashboard/mobile/ManageOnlineAdMbComp'
import AdminDashSidebarSidebarComp from '../../components/mobile/AdminDashSidebarSidebarComp'
const ManageOnlineAdmission = () => {
  function setBodyColor({color}) {
    document.documentElement.style.setProperty('--bodyColor', color)
}

  setBodyColor({color: "#f2f2f2"})
  return (
    <>
        <div className="desktop mngonlnadmsn">
            <ManageOnlineAdmissionComp/>
        </div>
       
            <div className="mobile">
            <div className="overlayfordrpdwn"></div>
              <AdminDashSidebarSidebarComp />
              <ManageOnlineAdMbComp/>
            </div>
             
    </>
  )
}

export default ManageOnlineAdmission